import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  customers: [],
  employees: [],
  customer: {},
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalCustomers: 0,
    totalPages: 0
  },
  customersCatalog: {},
  filterParams: '',
  isModalVisible: false,
  isModalEmployeeVisible: false,
  isModalShowEmployeeVisible: false
}

const mutations = {
  SET_CUSTOMERS (state, payload) {
    state.customers = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalCustomers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_EMPLOYEES (state, payload) {
    state.employees = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalCustomers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_CUSTOMER (state, payload) {
    state.customer = payload.data
  },
  ADD_CUSTOMER (state, payload) {
    state.customers.push(payload)
  },
  ADD_EMPLOYEE (state, payload) {
    state.employees.push(payload)
  },
  UPDATE_EMPLOYEE (state, payload) {
    const idx = state.employees.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.employees, idx, payload)
    }
  },
  UPDATE_CUSTOMER (state, payload) {
    const idx = state.customers.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.customers, idx, payload)
    }
  },
  DELETE_CUSTOMER (state, payload) {
    const idx = state.customers.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.customers, idx)
    }
  },
  DELETE_CUSTOMERS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.customers.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.customers, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_EMPLOYEE_VISIBLE (state, payload) {
    state.isModalEmployeeVisible = payload
  },
  SET_MODAL_SHOW_EMPLOYEE_VISIBLE (state, payload) {
    state.isModalShowEmployeeVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.customersCatalog[object] = payload.data
  },
  CLEAN_CUSTOMERS_DASHBOARD (state) {
    state.customersDashboard = []
  },
  SET_CUSTOMER_ID_DASHBOARD (state, payload) {
    state.selectedCustomerIdDashboard = payload.customer_id
  }
}

const actions = {
  async loadCustomers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customers?page=${payload.page}${state.filterParams}${payload.customerId}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCustomerEmployer ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`employees?&page=${payload.page}${state.filterParams}&employer_id=${payload.employer}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EMPLOYEES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadShowEmployees ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`employees?&page=${payload.page}&employer_id=${payload.employer}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EMPLOYEES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadEmployees ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`employees?&page=${payload.page}${state.filterParams}&employer_id=${payload.employer}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EMPLOYEES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCustomer ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customers/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addEmployee ({ commit }, payload) {
    let formData = new FormData()
    formData.append('contact', payload.customer.contact)
    formData.append('phone', payload.customer.phone)
    formData.append('email', payload.customer.email)
    formData.append('password', payload.customer.password)
    formData.append('user_id', payload.customer.user_id)
    formData.append('customer_id', payload.customer.id)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`customers/employees`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_EMPLOYEE', response.data)
        commit('SET_MODAL_EMPLOYEE_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.employee', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async addCustomer ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('name', payload.customer.name)
    formData.append('contact', payload.customer.contact)
    formData.append('phone', payload.customer.phone)
    formData.append('website', payload.customer.website)
    formData.append('email', payload.customer.email)
    formData.append('password', payload.customer.password)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`customers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CUSTOMER', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_MODAL_REVISION_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_LOADING', false, { root: true })
      }
    } catch (e) {
      commit('SET_MODAL_REVISION_VISIBLE', false)
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editEmployee ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`employees/${payload.employee.id}`, payload.employee)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_EMPLOYEE_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.employees', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editCustomer ({ commit }, payload) {
    let formData = new FormData()

    if (payload.file) {
      formData.append('importFile', payload.file)
    }

    formData.append('name', payload.customer.name)
    formData.append('contact', payload.customer.contact)
    formData.append('phone', payload.customer.phone)
    formData.append('website', payload.customer.website)
    formData.append('email', payload.customer.email)
    if ('password' in payload.customer) {
      formData.append('password', payload.customer.password)
    }
    formData.append('_method', 'PUT')

    app.$Progress.start()

    try {
      let response = await axios.post(`customers/${payload.customer.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CUSTOMER', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editUser ({ commit }, payload) {
    const user = {
      name: payload.name,
      email: payload.email
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`users/${payload.id}`, user)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CUSTOMER', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCustomer ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`customers/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CUSTOMER', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCustomers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`customers/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CUSTOMERS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionCustomer ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`customers/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CUSTOMER', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.customers', text: `customers.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/customers/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalEmployeeVisible ({ commit }, payload) {
    commit('SET_MODAL_EMPLOYEE_VISIBLE', payload)
  },
  setModalShowEmployeeVisible ({ commit }, payload) {
    commit('SET_MODAL_SHOW_EMPLOYEE_VISIBLE', payload)
  }
}

const getters = {
  customers: state => state.customers,
  employees: state => state.employees,
  customer: state => state.customer,
  customersCatalog: state => state.customersCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalEmployeeVisible: state => state.isModalEmployeeVisible,
  isModalShowEmployeeVisible: state => state.isModalShowEmployeeVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
